import { SearchInput } from '../shared';
import { SortOrder, OfficeEquipmentTypeSortType } from '../enums';

export class GetOfficeEquipmentTypesInput extends SearchInput<OfficeEquipmentTypeSortType> {
    constructor() {
        super(OfficeEquipmentTypeSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
